/**
 * Settings write privilege for the dashboard UI.
 *
 * Auth-off (null user) can write: the orchestrator is running with
 * authentication disabled, so there is no session to gate. When auth is on,
 * only `admin` can write. Unknown roles fail closed. Server routes still
 * enforce `requireAdmin` independently.
 */
export function canWriteSettings(user: { role: string } | null): boolean {
  if (user === null) return true;
  return user.role === 'admin';
}

/** Deploy is an admin act; an absent identity cannot deploy. */
export function canDeploy(user: { role: string } | null): boolean {
  return canWriteSettings(user);
}
